import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { getUser } from '../Api'

export default generateApiAction({
  baseType: Types.USERS.GET,
  api: getUser,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/users/GetAction.js